module.exports = __webpack_public_path__ + "static/media/Roboto-ThinItalic.3ebe5873.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-ThinItalic.woff
// module id = 517
// module chunks = 0